import React, { useEffect, useMemo, useState } from "react"

import { Color } from "~tailwindui/types/enums"

import { Button } from "~tailwindui/Basics"

import EventEmitter from "src/EventEmitter"
import { tutorClient as client } from "src/urql-client"

import { gql, useMutation } from "hooks/urql"
import useWebsocket from "hooks/useWebsocket"

export type RequestProxyNumberProps = {
  studentId: string
}

const RequestProxyNumber: React.FC<RequestProxyNumberProps> = ({
  studentId,
}) => {
  const [mutationState, runMutation]: any[] = useMutation(
    requestNumberMutation,
    client
  )

  const [waiting, setWaiting] = useState(false)
  const [errorMessage, setErrorMessage] = useState<string | null>()

  const channelProps = useMemo(() => {
    return {
      channelName: "StudentChannel",
      channelProps: { id: studentId },
    }
  }, [studentId])

  useWebsocket(channelProps)

  useEffect(() => {
    const onNumberCreated = () => {
      window.location.reload()
    }
    EventEmitter.subscribe("numberCreated", onNumberCreated)
    return () => EventEmitter.unsubscribe("numberCreated", onNumberCreated)
  }, [])

  const handleClick = () => {
    runMutation({ studentId })
      .then(
        response => {
          const { failures } = response.data.requestProxyNumber
          if (failures.length > 0) setErrorMessage(failures[0].message)
          else setWaiting(true)
        },
        () => setErrorMessage("Something went wrong")
      )
      .catch(() => setErrorMessage("Something went wrong"))
  }

  return (
    <>
      {errorMessage && <div className="alert mb-3">{errorMessage}</div>}
      <Button
        onClick={handleClick}
        className="flex items-center"
        color={Color.Orange}
        soft
        loading={waiting || mutationState.fetching}
      >
        Request Number
      </Button>
    </>
  )
}

const requestNumberMutation = gql`
  mutation requestProxyNumber($studentId: ID!) {
    requestProxyNumber(studentId: $studentId) {
      failures {
        message
      }
    }
  }
`

export default RequestProxyNumber
